import { withSvgIcon } from './withSvgIcon';

export const FolderClosed = withSvgIcon(
  <path
    d="M1 3.5C1 2.55719 1 2.08579 1.29289 1.79289C1.58579 1.5 2.05719 1.5 3 1.5H5.67157C6.08032 1.5 6.2847 1.5 6.46847 1.57612C6.65224 1.65224 6.79676 1.79676 7.08579 2.08579L8.41421 3.41421C8.70324 3.70324 8.84776 3.84776 9.03153 3.92388C9.2153 4 9.41968 4 9.82843 4H15C15.9428 4 16.4142 4 16.7071 4.29289C17 4.58579 17 5.05719 17 6V14C17 14.9428 17 15.4142 16.7071 15.7071C16.4142 16 15.9428 16 15 16H3C2.05719 16 1.58579 16 1.29289 15.7071C1 15.4142 1 14.9428 1 14V3.5Z"
    stroke="currentColor"
    strokeWidth="currentWith"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 20 20' },
);
